import React from "react";

import { makeStyles } from "@mui/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import {
  GeneralEdit,
  DetailsEdit,
  ImpactEdit,
  ProjectionsEdit,
  ProgressEdit,
  ResultsEdit,
  CommentsEdit,
} from "./EditOptions/Index.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
  },
}));

function EditTabContent(
  { apiData, params, closeModal, category, groupParent },
  props
) {

  const paramsType = {
    general: GeneralEdit,
    details: DetailsEdit,
    impact: ImpactEdit,
    projections: ProjectionsEdit,
    progress: ProgressEdit,
    results: ResultsEdit,
    comments: CommentsEdit,
  };

  const SelectedParamsType = paramsType[params];
 // console.log(SelectedParamsType);

  const classes = useStyles();

  return (
    <SelectedParamsType
      apiData={apiData}
      params={params}
      closeModal={closeModal}
      category={category}
      groupParent={groupParent}
    />
  );
}

export default EditTabContent;
